import { render, staticRenderFns } from "./Advantage.vue?vue&type=template&id=338888d0&"
import script from "./Advantage.vue?vue&type=script&lang=js&"
export * from "./Advantage.vue?vue&type=script&lang=js&"
import style0 from "./Advantage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports